import { css } from '@emotion/react';

import { flex } from 'src/styles/utils';

import { colors } from '../../styles/colors';
import { ZeeFontRegular } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const footerMenuContainer = css`
  ${flex('column-reverse')};
  bottom: 0;
  ${MQ.MediaLg} {
    margin: 14px 0 0 0;
    ${flex('row', 'space-between')}
    width: 100%;
    padding: 0px;
  }
`;

export const copyrightText = css`
  color: ${colors.PrimaryWhiteColorAlpha50};
  ${ZeeFontRegular(12, 15)};
  padding: 0px 16px;
  margin-top: 8px;
  ${MQ.MediaMd} {
    padding: 0px 64px;
    ${ZeeFontRegular(14, 20)};
  }
  ${MQ.MediaLg} {
    padding: 0px;
    ${ZeeFontRegular(12, 18)};
  }
`;

export const footerContainerSubscription = css`
  border-top: 1px solid ${colors.PrimaryWhiteColorAlpha05};
  display: flex;
  width: 100%;
  margin-bottom: 100px;
  gap: 10px;
  flex-direction: column-reverse;
  align-items: center;
  ${MQ.MediaLg} {
    margin: 24px 0 0 0;
    ${flex('row', 'space-between')}
    width: 100%;
    padding: 0 24px;
  }
`;
export const footerContainer = css`
  border-top: 1px solid ${colors.PrimaryWhiteColorAlpha05};
  padding: 32px 0px;
  ${MQ.MediaMd} {
    padding: 40px 0px;
  }
  ${MQ.MediaLg} {
    padding: 26px 7.5%;
  }
`;

export const marginBottom = (margin: number) =>
  css`
    margin-bottom: ${margin}px;
  `;
